import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'mc-forbidden-access-dialog',
  templateUrl: './forbidden-access-dialog.component.html',
  styleUrls: ['./forbidden-access-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenAccessDialogComponent {
  constructor(public dialogRef: MatDialogRef<ForbiddenAccessDialogComponent>) {}
  close() {
    this.dialogRef.close();
  }
}
